import { fetchQuestionnaireQuestions, create, fetch, update, createAlert, deleteAlerts, deleteQuestion } from '@/services/questionnaire/questionService'

const state = {
  questionnaireQuestions: [],
  question: []
}

const getters = {
  questionnaireQuestions: (state) => state.questionnaireQuestions,
  question: (state) => state.question
}

const actions = {
  async fetchQuestionnaireQuestions({ commit, dispatch }, questionnaireId) {
    commit('setQuestionnaireQuestions', [])
    commit('setIsLoading', true)

    try {
      const { data } = await fetchQuestionnaireQuestions(questionnaireId)

      commit('setQuestionnaireQuestions', data)
    } catch ({ data }) {
      dispatch('showErrorMessage', data.message)
    } finally {
      commit('setIsLoading', false)
    }
  },
  async createQuestion({ commit }, {questionnaireId, params}) {
    commit('setIsLoading', true)
    return await create(questionnaireId, params);
  },
  async fetchQuestion({ commit, dispatch }, id) {
    try {
      const { data } = await fetch(id)
      commit('setQuestion', data)
    } catch ({ data }) {
      dispatch('showErrorMessage', data.message)
    }
  },
  async editQuestion({ commit }, params) {
    commit('setIsLoading', true)
    return await update(params);
  },
  async createQuestionAlert({ commit }, params) {
    commit('setIsLoading', true)
    return await createAlert(params);
  },
  async deleteAlertsFromQuestion({ commit }, id) {
    commit('setIsLoading', true)
    return await deleteAlerts(id)
  },
  async deleteQuestion(state, id) {
    return await deleteQuestion(id)
  }
}

const mutations = {
  setQuestionnaireQuestions: (state, questionnaireQuestions) => {
    state.questionnaireQuestions = questionnaireQuestions
  },
  setQuestion: (state, question) => {
    state.question = question
  },
}

export default {
  state,
  mutations,
  actions,
  getters,
}
